import { ListApplicationsQuery, RequestSupplement, UpdateApplicationStatus } from "@humanex/interfaces";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { applicationApiClient } from "@/libs/api";

export const applicationKeys = {
  all: ["applications"] as const,
  byProgram: (programId: string) => [...applicationKeys.all, "program", programId] as const,
  detail: (id: string) => [...applicationKeys.all, "detail", id] as const
};

export function useApplicationsByProgramQuery(programId: string, params?: Partial<ListApplicationsQuery>) {
  return useQuery({
    queryKey: applicationKeys.byProgram(programId),
    queryFn: () => applicationApiClient.getListByProgram(programId, params),
    enabled: !!programId
  });
}

export function useUpdateApplicationStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateApplicationStatus }) =>
      applicationApiClient.updateStatus(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationKeys.all });
    }
  });
}

export function useRequestSupplement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: RequestSupplement }) =>
      applicationApiClient.requestSupplement(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationKeys.all });
    }
  });
}
